import C from '../../../constants/accounting/payable/historyPreviewContractor';
import accountingServices from "../../../services/accountingServices";

export const activeScreenPreviewContractor = () => dispatch => {
    dispatch({type: C.ACTIVE_SCREEN_STATUS, payload: true})
}

export const getInvoiceContractorView = (id) => dispatch => {
    accountingServices.getInvoiceContractorDetail(id).then(res => {
        if(res.success) {
            dispatch({type: C.CHANGE_INVOICE_DETAIL, payload: res.data})
        }
    })
}

export const resetData = () => dispatch => {
    dispatch({type: C.RESET_DATA})
}